import { render, staticRenderFns } from "./paymentConfirmation.vue?vue&type=template&id=a84017cc&"
import script from "./paymentConfirmation.vue?vue&type=script&lang=js&"
export * from "./paymentConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports